const BASE_URL = window.location.origin.includes("localhost")
  ? `${window.location.origin}/wordpress`
  : window.location.origin;

export const useUpdatePaymentSuccess = () => {
  return async (requestKey, stepNum) => {
    const response = await fetch(
      `${BASE_URL}/wp-json/trumarket/v1/request/${requestKey}`,
      {
        method: "PATCH",
        body: JSON.stringify({
          data: [
            { kind: "N", path: ["paymentInfo", "paymentSuccess"], rhs: true },
            { kind: "N", path: ["stepNum"], rhs: stepNum },
          ],
        }),
      }
    );

    const partialData = await response;
    if (!response?.ok) return false;
    else return partialData;
  };
};
